/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_F3Inputs */

const en_mk_sol_konsultan_f3 = /** @type {(inputs: Mk_Sol_Konsultan_F3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notion or Confluence, Slack, a file folder per engagement`)
};

const id_mk_sol_konsultan_f3 = /** @type {(inputs: Mk_Sol_Konsultan_F3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notion atau Confluence, Slack, folder berkas per proyek`)
};

/**
* | output |
* | --- |
* | "Notion or Confluence, Slack, a file folder per engagement" |
*
* @param {Mk_Sol_Konsultan_F3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_f3 = /** @type {((inputs?: Mk_Sol_Konsultan_F3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_F3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_f3(inputs)
	return en_mk_sol_konsultan_f3(inputs)
});